import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import "./ViewUser.css"; // Optional for custom styling

const ViewUser = () => {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_SERVER}/api/user/${id}`)
      .then((res) => {
        setUser(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to load user", err);
        setLoading(false);
      });
  }, [id]);

  if (loading) return <p>Loading...</p>;

  if (!user) return <p>User not found.</p>;

  return (
    <div className="view-user-container">
      <h2>User Details</h2>
      <div className="user-info">
        <p>
          <strong>Name:</strong> {user.username}
        </p>
        <p>
          <strong>Email:</strong> {user.email}
        </p>
        <p>
          <strong>Phone:</strong> {user.phone}
        </p>
        <p>
          <strong>Address:</strong> {user.address}.
        </p>
        <p>
          <strong>Joined:</strong>{" "}
          {new Date(user.createdAt).toLocaleString()}
        </p>
        {/* Optional fields */}
        <p>
          <strong>Role:</strong> {user.role || "Customer"}
        </p>
      </div>

      <Link to="/admin/users">
        <button className="back-btn">Back to User List</button>
      </Link>
    </div>
  );
};

export default ViewUser;
